import React, { useState, useRef, useEffect } from "react";
import Rating from '@mui/material/Rating';

const PartFourTab = ({ questions, selectedAnswersPartIV, setSelectedAnswersPartIV }) => {
  const questionRefs = useRef([]);

    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
    

  const handleAnswerChange = (questionId, newValue, questionNumber) => {
    setSelectedAnswersPartIV((prevAnswers) => {
      const updatedAnswers = {
        ...prevAnswers,
        [questionId]: newValue, 
      };

      const nextQuestionIndex = questionNumber - 1;
      if (questionRefs.current[nextQuestionIndex]) {
        questionRefs.current[nextQuestionIndex].scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }

      return updatedAnswers;
    });
  };

  return (
    <div className="container mx-auto px-6 py-8">
      <div className="parts pl-24 pr-24 question-header text-gray-800 text-left mb-4">
        Values are beliefs that influence your behavior and decision-making. For example, if you believe that telling the truth is very important, you will try to be truthful when you deal with other people. On the following pages is a list of beliefs that guide people’s behavior and helps them make important decisions. Read each one and then choose the response (1-5) that best describes how often the belief guides your behavior.
      </div>
      <div className=" parts pl-24 pr-24 text-xl text-gray-800 mb-12">
        If a belief almost never guides your behavior, circle 1. If a belief almost always guides your behavior, circle 5. If the best answer for you is between 1 and 5, circle the number 2, 3, or 4 that most accurately describes how this belief guides your behavior.
      </div>
      <div className=" parts pl-24 pr-24">
        {questions.map((question, index) => (
          <div key={question.id} ref={(el) => (questionRefs.current[index] = el)} className="">
            <div className="question-text p-4 text-gray-700 mb-10 bg-white shadow-lg">
              Question {question.n}: {question.text}
              <div className=" rating star pt-4  text-center">
                <Rating
                  name={`rating-${question.id}`} // unique name for each rating
                  value={selectedAnswersPartIV[question.id] || 1} // If no value is set, default to 1
                  onChange={(event, newValue) => handleAnswerChange(question.id, newValue, question.n)} // Handle change
                  size="large"
                  className="rating-star"
                  sx={{
                    gap: 10,
                    '& .MuiRating-icon': {
                      fontSize: '2rem', // Default size
                    },
                    '@media (max-width: 808px)': {
                      gap: 2,
                      '& .MuiRating-icon': {
                        fontSize: '2rem', // Font size for smaller screens
                      },
                    },
                
                  }}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PartFourTab;
